import { useBranding, resolveAssetUrl } from "@/contexts/BrandingContext";

const SIZES = { sm: "h-9", md: "h-10", lg: "h-12", xl: "h-14", "2xl": "h-20" };

export const BrandLogo = ({ size = "md", compact = false, className = "" }) => {
  const { logo_url, company_name, short_name, brand_color } = useBranding();
  const src = resolveAssetUrl(logo_url);
  if (src) return <img src={src} alt={company_name || "Company logo"} className={`${SIZES[size]} object-contain ${className}`} data-testid="brand-logo" />;
  if (compact) {
    return (
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-md font-heading text-sm font-black text-white" style={{ backgroundColor: brand_color }} data-testid="brand-logo-compact">
        {(short_name || company_name || "?").slice(0, 2)}
      </span>
    );
  }
  return (
    <span className={`font-heading text-lg font-extrabold tracking-tight leading-tight ${className}`} style={{ color: brand_color }} data-testid="brand-logo-text">
      {company_name || "Your company"}
    </span>
  );
};
